import { request } from 'graphql-request';

export default class Storefront {
  constructor({ shopifyDomain, storefrontAccessToken }) {
    this.storefrontAccessToken = storefrontAccessToken;
    this.apiUrl = `https://${shopifyDomain}/api/2023-10/graphql.json`;
    this.userAuth = '';
  }

  async getRequest({ query, variables }) {
    try {
      const result = await request(this.apiUrl, query, variables, {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': this.storefrontAccessToken
      });

      return result;
    } catch (e) {
      console.error('Storefront getRequest error ', e);
      return {};
    }
  }
}
